import { render, staticRenderFns } from "./Mp3Player.vue?vue&type=template&id=6edea353&scoped=true&"
import script from "./Mp3Player.vue?vue&type=script&lang=js&"
export * from "./Mp3Player.vue?vue&type=script&lang=js&"
import style0 from "./Mp3Player.vue?vue&type=style&index=0&id=6edea353&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edea353",
  null
  
)

export default component.exports